// Unfortunately, import order matters here due to
// all sorts of stuff being set and depended upon in global scope.
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';

import $ from 'jquery';

declare global {
  interface Window {
    jQuery: typeof $;
    $: typeof $;
  }
}

window.jQuery = window.$ = $;

import { initializeSentry } from 'js/utils/initializeSentry';

initializeSentry();

import 'js/single_work/_namespace';
import 'js/single_work/preview_controller';
import { watchDomImpressions } from 'js/utils/impressions/watchDomImpressions';
import routes from 'js/core_pre_webpack/routes';
import { set_gmtoffset } from 'js/core_webpack/metrics/gmt_offset';
import ConfirmationBanner from 'js/single_work/loswp/ConfirmationBanner';
import { loadRecordHit } from 'js/utils/loadRecordHit';
import { currentUser } from 'js/utils/user';
import { startActivityTracking } from 'js/core_webpack/metrics/page_activity_tracking';
import { setUpHeaders } from 'js/single_work/loswp/setUpHeaders';
import { setUpLoginButtons } from 'js/simple_layout/header/setUpHeader';
import setUpScribdDocument from 'js/single_work/loswp/setUpScribdDocument';
import setUpClickTracking from 'js/single_work/loswp/setUpClickTracking';
import { setUpFigureCarousel } from 'js/single_work/loswp/setUpFigureCarousel';
import setUpViewMoreRelatedWorks from 'js/single_work/loswp/setUpViewMoreRelatedWorks';
import { setUpTruncateComponent } from 'js/single_work/loswp/setUpTruncateComponent';
import { MoreActionsMenu } from 'js/single_work/loswp/MoreActionsMenu';
import registerForRails from 'js/utils/registerForRails';
import { CitationButton } from 'js/single_work/loswp/CitationButton';
import { init4gen } from 'js/scribd_api/4gen';
import { LoginModalManager } from 'js/login_modal/LoginModalManager';
import { setUpOutline } from 'js/single_work/loswp/setUpOutline';
import { initializeClaims } from 'js/single_work/loswp/claim_to_highlight/claimToHighlight';
import { FeatureFeedback } from 'js/feature_feedback/FeatureFeedback';

if (window.loswp.useOptimizedScribd4genScript) {
  init4gen();
}

import { trackCWV } from 'js/utils/trackCWV';
trackCWV(window.loswp.cwvAbTestBucket);

// On some versions of LOSWP (drawbridge) the previewable
// attachments are retrieved server side.
setUpScribdDocument({
  work: window.loswp.work,
  previewableAttachments: window.loswp.previewableAttachments,
  hasViewableAttachments: window.loswp.hasViewableAttachments,
});

setUpHeaders();
setUpLoginButtons({ pageName: 'loswp' });
setUpClickTracking(window.loswp.work.id, window.loswp.designVariant);
setUpFigureCarousel();
setUpViewMoreRelatedWorks('related-work', ['large']);
setUpViewMoreRelatedWorks('cited-by', ['large']);
setUpViewMoreRelatedWorks('cited-by-v2', ['small', 'medium', 'large']);
setUpViewMoreRelatedWorks('cited-by-v2-related-work', [
  'small',
  'medium',
  'large',
]);
setUpTruncateComponent('abstract', 16, ['small', 'medium', 'large']);
setUpTruncateComponent('transcript', 4, ['small', 'medium', 'large']);
setUpOutline();
initializeClaims();

loadRecordHit().then(() => {
  // Don't start activity tracking until the hit is loaded, it needs the hit ID
  startActivityTracking();
});

// _footer.html.slim -> application_helper.rb
if (window.loswp.shouldDetectTimezone) {
  set_gmtoffset(routes.gmtoffset_path({}));
}

// Confirmation banner, comes from show.html+fast.slim.
// Shown for new user accounts that haven't been confirmed yet
// or have been flagged as spam.
if (window.confirmAccountEmail) {
  const user = currentUser;
  const headerContainer = document.querySelector('#main-header-container');
  if (user && headerContainer?.parentElement) {
    const container = document.createElement('div');
    headerContainer.parentElement.insertBefore(
      container,
      headerContainer.nextSibling,
    );

    ReactDOM.render(
      <ConfirmationBanner email={window.confirmAccountEmail} user={user} />,
      container,
    );
  }
}

registerForRails({
  CitationButton,
  LoginModalManager,
  MoreActionsMenu,
  FeatureFeedback,
});

// Watch impressions for all elements with the `data-impression-entity-id` attribute
watchDomImpressions();

import { startRecordingIfSamplingRequest } from 'js/fullstory';
startRecordingIfSamplingRequest();
